
import { MultiselectFilterConfig, type MultiSelectValue } from './multiselect-filter-config';
import {OptionsMap} from "@/types";

/**
 * Same data-shape as MultiselectFilterConfig but the options list is fetched
 * dynamically using the current param value as a filter (server-side search).
 */
export class MultiselectSearchFilterConfig extends MultiselectFilterConfig {
  /**
   * Bucket filter stores either a search phrase (string) or already-selected
   * items (array) – neither is "empty" unless truly blank.
   */
  override isEmpty(value: unknown): boolean {
    if (typeof value === 'string') return value.trim() === '';
    return super.isEmpty(value as MultiSelectValue);
  }

  /**
   * Converts a raw search phrase (typed by the user) to a query value sent
   * to the API for filtering available bucket options – distinct from toQuery()
   * which serializes already-selected values.
   */
  toQueryBucket(phrase: string): string | null {
    return phrase || null;
  }

  override async resolveOptions(paramValue: string): Promise<OptionsMap> {
    if (!this.optionsProvider) return {};
    return this.optionsProvider([paramValue]);
  }
}

